import { createAction } from '@'
import { $tableFilter } from '../stores'

export default createAction('table:SetTableFilter', (name, filter) => {
    $tableFilter.subStore(name).setState(s => ({
        ...s,
        ...filter
    }))
})
